import {useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'
import {type SupportedLocales, useLocale} from '@/lib/locale/locale'
import queries from '@/queries/queries'
import {getCart} from '@/services/cartService'

function getWalletQueryOptions(isAuthenticated: boolean, locale: SupportedLocales) {
  return queries.getQueryOptions({
    name: 'cart',
    params: [locale],
    queryFn: async ({signal}) => getCart({isAuthenticated, signal, locale}),
    select: data => {
      return data.wallet
    },
  })
}

export function useWallet() {
  const [locale] = useLocale()
  const isAuthenticated = useIsAuthenticatedValue()
  const walletQueryOptions = getWalletQueryOptions(isAuthenticated, locale)
  return useQuery(walletQueryOptions)
}
